// extracted by mini-css-extract-plugin
module.exports =  {"configure-input-container":"configure-input-container-IqUdN","label":"label-bkapj","configure-button-container":"configure-button-container-tJJ5b","icon":"icon-DoVQm"};